export function initAjaxPagination(url, scroll=false) {
    $.ajax({
        url: url,
        dataType: 'json',
        success: function (response) {
            const $container = $(response.data.ajaxPaginationContainer);
            $container.html(response.data.html);
            if(scroll){
                $('html, body').animate({
                    scrollTop: $container.offset().top - 170
                }, 'slow');
            }
        }
    });
}

$(function () {
    $(document).on("click", '.pagination.ajax a', function (e) {
        e.preventDefault();
        const url = $(this).attr('href');
        initAjaxPagination(url, true);
    });
});
